var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.buttons)?_c('div',{staticClass:"button-bar"},_vm._l((_vm.buttons),function(button,index){return _c('router-link',{key:index,attrs:{"to":_vm.get_link(button.route)}},[_c('button',{staticClass:"menu-button",class:button.icon},[_vm._v(_vm._s(button.text))])])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }